module.exports = __webpack_public_path__ + "img/LA.b76f93a9.svg";